import React, { FC } from 'react';
import { getIn } from 'formik';

import { CircularProgress } from '@mui/material';

import { useFuturesExchangesViewQuery } from '../../hooks';
import FormikAutocomplete from '../FormikAutocomplete/FormikAutocomplete';

export interface FuturesExchangeAutocompleteProps {
  formik: any;
  openOnFocus?: boolean;
}

const FuturesExchangeAutocomplete: FC<FuturesExchangeAutocompleteProps> = (props) => {
  const allOptions = useFuturesExchangesViewQuery().data;
  if (!allOptions) {
    return <CircularProgress />;
  }
  let activeOptions = allOptions.sort((a, b) =>
    (a.exchangeName ?? '').localeCompare(b.exchangeName ?? '')
  );

  let optionsById = new Map(
    activeOptions?.map((ta) => [ta.exchangeId as number, ta.exchangeName as string])
  );

  const value = getIn(props.formik.values, 'exchangeId');
  if (value && !optionsById.get(value)) {
    const missingOption = allOptions.find((t) => t.exchangeId === value);
    if (missingOption) {
      activeOptions = [...activeOptions, missingOption];
      optionsById = new Map(
        activeOptions?.map((ta) => [ta.exchangeId as number, ta.exchangeName as string])
      );
    }
  }

  return (
    <FormikAutocomplete
      formik={props.formik}
      field="exchangeId"
      openOnFocus={props.openOnFocus}
      optionsAsMap={optionsById}
    ></FormikAutocomplete>
  );
};

export default FuturesExchangeAutocomplete;
